import "./PopoverMenu.scss";

import { useContext, useRef, useEffect } from 'react';
import PropTypes from "prop-types";

import { MasterContext }    from 'master_context';

const PopoverMenu = ({ linkData, top, bottom, left, right }) => {
  const { PopoverContext } = useContext(MasterContext);
  const { ref } = PopoverContext;

  const firstLinkRef = useRef(null);

  useEffect(() => {
    if (firstLinkRef.current) {
      firstLinkRef.current.focus()
    }
  }, [firstLinkRef])

  return (
    <div role="dialog" ref={ref} style={{top, bottom, left, right}}className="PopoverMenu">
      {Object.keys(linkData).filter((key) => linkData[key]['show']).map((key, index) => {
        const { title, link, icon, target, rel } = linkData[key];

        const menuItem = (
          <a className="PopoverMenu__item" target={target ?? undefined} rel={rel ?? undefined} key={key} href={link}>
            {icon}
            {title}
          </a>
        );

        if (index === 0) return {...menuItem}

        return menuItem;
      })}
    </div>
  );
}

PopoverMenu.propTypes = {
  activeApp: PropTypes.string,
  isAdmin: PropTypes.bool,
  isBroker: PropTypes.bool,
  isMember: PropTypes.bool,
}

export default PopoverMenu;
